import type { ClientAdd, ClientUpdate } from "../models/client";
import { createCrudStoreBundle } from "./crud.store";
import type { ApiClient, EntityWithId } from "./shared";

/** Raw API client entity (round-trip via Client.raw in parsers). */
export interface ClientEntity extends EntityWithId {
	readonly [key: string]: unknown;
}

export const createClientsStore = (apiClient: ApiClient) =>
	createCrudStoreBundle<ClientEntity, ClientAdd, ClientUpdate>({
		apiClient,
		entityPath: "clients",
	});
